// src/features/ucits-etf/routes.ts
//
// Single source of truth for cross-feature deep-links out of the UCITS-ETF
// dashboard. Every place that links a UCITS symbol to the currency-aware ETF
// deep-dive (AutoSuggest rows, Screener table cells, BreakoutBoard tiles)
// routes through `etfInfoPath` so the target path is defined exactly once.
//
// The deep-dive page lives at `/dashboard/etf-info-page` and reads the fund
// via the `?symbol=` query param (see features/etf-info/EtfInfoPage.tsx). The
// page resolves the display currency itself via `resolveCurrency`, so no
// extra query params are required.

/** Base path of the currency-aware ETF deep-dive page. */
export const ETF_INFO_ROUTE = '/dashboard/etf-info-page';

/**
 * Build the deep-link URL for a fund's ETF Info page. The symbol is
 * URL-encoded so exotic tickers (dots, carets, spaces) survive intact.
 */
export const etfInfoPath = (symbol: string): string =>
    `${ETF_INFO_ROUTE}?symbol=${encodeURIComponent(symbol)}`;
